export const englishFooterSchema = {
  numberOfColumns: 2,
  socialMediaLinks: [
    {
      link: {
        fieldType: 'socialMediaLink',
        platform: 'facebook',
        url: 'https://www.facebook.com/Sharetribe/',
      },
      blockType: 'socialMediaLink',
    },
    {
      link: {
        fieldType: 'socialMediaLink',
        platform: 'twitter',
        url: 'https://twitter.com/sharetribe',
      },
      blockType: 'socialMediaLink',
    },
    {
      link: {
        fieldType: 'socialMediaLink',
        platform: 'youtube',
        url: 'https://www.youtube.com/@Sharetribe',
      },
      blockType: 'socialMediaLink',
    },
  ],
  blocks: [
    {
      blockType: 'footerBlock',
      text: {
        content:
          '- [Our Story](/p/about)\n- [FAQ](/p/faq)\n- [Search a Listing](/s)\n- [Post a Listing](/l/new)',
        fieldType: 'markdown',
      },
      blockId: 'general',
    },
    {
      blockType: 'footerBlock',
      text: {
        content: '- [Terms of Service](/terms-of-service)\n- [Privacy Policy](/privacy-policy)',
        fieldType: 'markdown',
      },
      blockId: 'terms-and-privacy',
    },
    {
      blockType: 'footerBlock',
      blockId: 'localisations',
      text: {
        content:
          '**Where are we present?**\n- Paris\n- Disneyland Paris\n- Orly Airport\n- CDG Airport\n- Paris Train Stations\n- Île de France',
        fieldType: 'markdown',
      },
    },
  ],
  slogan: {
    content: 'Vacation Facilitator',
    fieldType: 'text',
  },
  copyright: {
    content: '© 2024 Bambigo. All rights reserved.',
    fieldType: 'text',
  },
  sectionId: 'footer',
  sectionType: 'footer',
};
